{
  "planning.tab": "الخطة",
  "planning.save": "حفظ",
  "planning.saving": "جارٍ الحفظ…",
  "planning.loadError": "تعذّر تحميل الخطة.",
  "planning.phase.default.strategy": "الاستراتيجية",
  "planning.phase.default.design": "التصميم",
  "planning.phase.default.build": "التنفيذ",
  "planning.phase.default.grow": "النمو",
  "planning.phase.status.upcoming": "قادمة",
  "planning.phase.status.active": "جارية",
  "planning.phase.status.done": "منتهية",
  "planning.phase.status.late": "متأخرة",
  "planning.milestone.status.upcoming": "قادمة",
  "planning.milestone.status.active": "جارية",
  "planning.milestone.status.late": "متأخرة",
  "planning.milestone.status.done": "تحققت",
  "planning.dates": "{start} – {end}",
  "planning.due.inDays": "{count, plural, zero {مستحقة اليوم} one {مستحقة غدًا} two {مستحقة بعد يومين} few {مستحقة بعد # أيام} many {مستحقة بعد # يومًا} other {مستحقة بعد # يوم}}",
  "planning.due.lateBy": "{count, plural, zero {متأخرة اليوم} one {متأخرة يومًا واحدًا} two {متأخرة يومين} few {متأخرة # أيام} many {متأخرة # يومًا} other {متأخرة # يوم}}",
  "planning.due.reachedOn": "تحققت في {date}",
  "planning.due.startsIn": "{count, plural, zero {تبدأ اليوم} one {تبدأ غدًا} two {تبدأ بعد يومين} few {تبدأ بعد # أيام} many {تبدأ بعد # يومًا} other {تبدأ بعد # يوم}}",
  "planning.summary.label": "الخطة في لمحة",
  "planning.summary.currentMilestone": "المحطة الحالية",
  "planning.summary.allReached": "تحققت كل المحطات",
  "planning.summary.inPhase": "المرحلة: {name}",
  "planning.summary.day": "اليوم {count, number} من {total, number}",
  "planning.summary.nextMilestone": "المحطة التالية",
  "planning.summary.noNextMilestone": "لا محطات قادمة",
  "planning.summary.late": "محطات متأخرة",
  "planning.summary.lateNone": "لا شيء متأخر",
  "planning.timeline.title": "الخط الزمني",
  "planning.timeline.label": "محطات المشروع ومراحلها على الخط الزمني",
  "planning.timeline.today": "اليوم",
  "planning.timeline.end": "النهاية",
  "planning.timeline.endLabel": "ينتهي المشروع في {date}",
  "planning.timeline.milestones": "المحطات",
  "planning.timeline.legendDue": "موعد المحطة",
  "planning.timeline.noDates": "لم تُحدد تواريخها بعد",
  "planning.timeline.duration": "{count, plural, zero {أقل من يوم} one {يوم واحد} two {يومان} few {# أيام} many {# يومًا} other {# يوم}}",
  "planning.timeline.overran": "{count, plural, zero {في موعدها} one {تجاوزت بيوم} two {تجاوزت بيومين} few {تجاوزت بـ# أيام} many {تجاوزت بـ# يومًا} other {تجاوزت بـ# يوم}}",
  "planning.timeline.addOn": "محطة جديدة تبدأ في {date}",
  "planning.timeline.milestoneLabel": "{name}: {date}، {status}",
  "planning.phases.list": "مراحل {name}",
  "planning.phases.edit": "تعديل {name}",
  "planning.phases.moveUp": "تقديم {name}",
  "planning.phases.moveDown": "تأخير {name}",
  "planning.phases.noDates": "بلا تواريخ",
  "planning.phases.from": "من {date}",
  "planning.phases.until": "حتى {date}",
  "planning.phases.outside": "خارج تواريخ المحطة ({start} – {end})",
  "planning.phases.progressLabel": "المهام المنجزة في {name}",
  "planning.phases.empty": "قسّم هذه المحطة إلى مراحل، أو ابدأ بمراحل الوكالة الأربع: الاستراتيجية والتصميم والتنفيذ والنمو.",
  "planning.phases.emptyReadOnly": "لا مراحل لهذه المحطة.",
  "planning.phases.addDefaults": "إضافة المراحل الافتراضية",
  "planning.phases.addingDefaults": "جارٍ الإضافة…",
  "planning.phases.defaultsAdded": "أُضيفت المراحل الأربع.",
  "planning.phases.defaultsExist": "لهذه المحطة مراحل بالفعل.",
  "planning.phases.add": "إضافة مرحلة",
  "planning.phases.delete": "حذف {name}",
  "planning.phases.deleteTitle": "حذف المرحلة «{name}»؟",
  "planning.phases.deleteBody": "تبقى مهامها في المحطة، لكن بلا مرحلة.",
  "planning.phases.deleteConfirm": "حذف المرحلة",
  "planning.phases.deleted": "تم حذف المرحلة.",
  "planning.phases.saved": "تم حفظ المرحلة.",
  "planning.phaseDialog.newTitle": "مرحلة جديدة",
  "planning.phaseDialog.editTitle": "تعديل المرحلة",
  "planning.phaseDialog.name": "الاسم",
  "planning.phaseDialog.namePlaceholder": "الاستكشاف",
  "planning.phaseDialog.startsOn": "تبدأ",
  "planning.phaseDialog.endsOn": "تنتهي",
  "planning.phaseDialog.datesHint": "التواريخ اختيارية، ويمكنك تحديدها لاحقًا.",
  "planning.phaseDialog.endBeforeStart": "تاريخ النهاية قبل البداية.",
  "planning.phaseDialog.outside": "هذه التواريخ خارج مدة {name} ({start} – {end}). يمكنك حفظها مع ذلك.",
  "planning.phaseDialog.create": "إضافة المرحلة",
  "planning.phaseDialog.created": "تمت إضافة المرحلة.",
  "planning.phaseDialog.errors.name": "اكتب اسمًا للمرحلة.",
  "planning.milestones.title": "المحطات",
  "planning.milestones.new": "محطة جديدة",
  "planning.milestones.empty.title": "لا محطات بعد",
  "planning.milestones.empty.body": "المحطة فترة عمل لها بداية ونهاية، مثل اعتماد أو نسخة تجريبية أو إطلاق. قسّم كل محطة إلى مراحل.",
  "planning.milestones.empty.readOnly": "يخطط قائد المشروع المحطات هنا.",
  "planning.milestones.complete": "تحديد {name} كمحطة متحققة",
  "planning.milestones.reopen": "إعادة فتح {name}",
  "planning.milestones.completed": "تحققت «{name}».",
  "planning.milestones.reopened": "أُعيد فتح «{name}».",
  "planning.milestones.menu": "خيارات {name}",
  "planning.milestones.edit": "تعديل",
  "planning.milestones.viewTasks": "عرض المهام",
  "planning.milestones.delete": "حذف",
  "planning.milestones.tasks": "{total, plural, zero {لا مهام بعد} one {أُنجزت {done, number} من مهمة واحدة} two {أُنجزت {done, number} من مهمتين} few {أُنجزت {done, number} من # مهام} many {أُنجزت {done, number} من # مهمة} other {أُنجزت {done, number} من # مهمة}}",
  "planning.milestones.phaseCount": "{count, plural, zero {لا مراحل} one {مرحلة واحدة} two {مرحلتان} few {# مراحل} many {# مرحلة} other {# مرحلة}}",
  "planning.milestones.progressLabel": "المهام المنجزة في {name}",
  "planning.milestones.deleteTitle": "حذف «{name}»؟",
  "planning.milestones.deleteBody": "تُحذف مراحلها معها، وتبقى مهامها في المشروع بلا محطة.",
  "planning.milestones.deleteConfirm": "حذف المحطة",
  "planning.milestones.deleting": "جارٍ الحذف…",
  "planning.milestones.deleted": "تم حذف المحطة.",
  "planning.milestoneDialog.newTitle": "محطة جديدة",
  "planning.milestoneDialog.editTitle": "تعديل المحطة",
  "planning.milestoneDialog.name": "الاسم",
  "planning.milestoneDialog.namePlaceholder": "إطلاق النسخة التجريبية",
  "planning.milestoneDialog.startsOn": "تبدأ",
  "planning.milestoneDialog.dueOn": "تنتهي",
  "planning.milestoneDialog.description": "ملاحظات",
  "planning.milestoneDialog.descriptionPlaceholder": "متى نعتبرها متحققة؟",
  "planning.milestoneDialog.create": "إضافة المحطة",
  "planning.milestoneDialog.created": "تمت إضافة المحطة.",
  "planning.milestoneDialog.saved": "تم حفظ المحطة.",
  "planning.milestoneDialog.errors.name": "اكتب اسمًا للمحطة.",
  "planning.milestoneDialog.errors.startsOn": "اختر تاريخ بدايتها.",
  "planning.milestoneDialog.errors.dueOn": "اختر تاريخ نهايتها.",
  "planning.milestoneDialog.errors.dueBeforeStart": "تاريخ النهاية قبل البداية.",
  "planning.labels.title": "الوسوم",
  "planning.labels.new": "وسم جديد",
  "planning.labels.empty": "لا وسوم بعد. تجمع الوسوم المهام عبر الأعمدة، مثل «محتوى» أو «متوقفة».",
  "planning.labels.edit": "تعديل {name}",
  "planning.labels.delete": "حذف {name}",
  "planning.labels.deleteTitle": "حذف الوسم «{name}»؟",
  "planning.labels.deleteBody": "سيُزال من كل المهام التي تحمله.",
  "planning.labels.deleteConfirm": "حذف الوسم",
  "planning.labels.deleted": "تم حذف الوسم.",
  "planning.labelDialog.newTitle": "وسم جديد",
  "planning.labelDialog.editTitle": "تعديل الوسم",
  "planning.labelDialog.name": "الاسم",
  "planning.labelDialog.namePlaceholder": "محتوى",
  "planning.labelDialog.color": "اللون",
  "planning.labelDialog.create": "إضافة الوسم",
  "planning.labelDialog.saved": "تم حفظ الوسم.",
  "planning.labelDialog.errors.name": "اكتب اسمًا للوسم.",
  "planning.labelDialog.errors.taken": "يوجد في المشروع وسم بهذا الاسم.",
  "planning.label.color.sage": "زيتي",
  "planning.label.color.blue": "أزرق",
  "planning.label.color.violet": "بنفسجي",
  "planning.label.color.amber": "كهرماني",
  "planning.label.color.rose": "وردي",
  "planning.label.color.teal": "فيروزي",
  "planning.label.color.slate": "رمادي",
  "planning.task.milestone": "المحطة",
  "planning.task.noMilestone": "بلا محطة",
  "planning.task.milestoneSearch": "ابحث في المحطات",
  "planning.task.noMilestoneMatch": "لا توجد محطة مطابقة.",
  "planning.task.labels": "الوسوم",
  "planning.task.noLabels": "بلا وسوم",
  "planning.task.editLabels": "تعديل الوسوم",
  "planning.task.labelSearch": "ابحث عن وسم أو أنشئ واحدًا",
  "planning.task.labelSearchOnly": "ابحث في الوسوم",
  "planning.task.createLabel": "إنشاء «{name}»",
  "planning.task.noLabelMatch": "لا يوجد وسم مطابق.",
  "planning.task.labelCreated": "تم إنشاء الوسم «{name}».",
  "planning.subtasks.title": "المهام الفرعية",
  "planning.subtasks.progressLabel": "{total, plural, zero {لا مهام فرعية} one {أُنجزت {done, number} من مهمة فرعية واحدة} two {أُنجزت {done, number} من مهمتين فرعيتين} few {أُنجزت {done, number} من # مهام فرعية} many {أُنجزت {done, number} من # مهمة فرعية} other {أُنجزت {done, number} من # مهمة فرعية}}",
  "planning.subtasks.empty": "قسّم المهمة إلى خطوات يسهل إنجازها.",
  "planning.subtasks.add": "إضافة مهمة فرعية",
  "planning.subtasks.addPlaceholder": "عنوان المهمة الفرعية",
  "planning.subtasks.addHint": "Enter للإضافة · Esc للإغلاق",
  "planning.subtasks.addError": "لم تُضف المهمة الفرعية. حاول مرة أخرى.",
  "planning.subtasks.markDone": "تحديد «{title}» كمنجزة",
  "planning.subtasks.markOpen": "إعادة «{title}» إلى غير منجزة",
  "planning.subtasks.loadError": "تعذّر تحميل المهام الفرعية.",
  "planning.subtasks.parent": "مهمة فرعية من {reference}",
  "planning.board.toolbar": "عرض اللوحة",
  "planning.board.showSubtasks": "المهام الفرعية",
  "planning.board.labelFilter": "تصفية حسب الوسم",
  "planning.board.anyLabel": "كل الوسوم",
  "planning.board.hiddenByFilter": "{count, plural, zero {لا مهام مخفية} one {أخفت التصفية مهمة واحدة} two {أخفت التصفية مهمتين} few {أخفت التصفية # مهام} many {أخفت التصفية # مهمة} other {أخفت التصفية # مهمة}}",
  "planning.card.subtasks": "{done, number}/{total, number}",
  "planning.card.moreLabels": "{count, plural, zero {لا وسوم أخرى} one {وسم آخر} two {وسمان آخران} few {# وسوم أخرى} many {# وسمًا آخر} other {# وسم آخر}}",
  "planning.card.subtaskOf": "مهمة فرعية من {reference}",
  "planning.list.labelFilter": "تصفية حسب الوسم",
  "planning.list.anyLabel": "أي وسم",
  "planning.list.milestoneFilter": "تصفية حسب المحطة",
  "planning.list.anyMilestone": "أي محطة",
  "planning.list.noMilestone": "بلا محطة",
  "planning.list.expand": "إظهار المهام الفرعية لـ {reference}",
  "planning.list.collapse": "إخفاء المهام الفرعية لـ {reference}",
  "planning.overview.title": "المحطات والمراحل",
  "planning.overview.open": "فتح الخطة",
  "planning.overview.current": "الآن",
  "planning.overview.next": "التالية",
  "planning.overview.late": "متأخرة",
  "planning.overview.noMilestones": "لا محطات مخطط لها بعد.",
  "planning.dependencies.title": "الاعتماديات",
  "planning.dependencies.blockedBy": "تنتظر",
  "planning.dependencies.blocking": "تنتظرها",
  "planning.dependencies.hidden": "مهمة لا يمكنك فتحها",
  "planning.dependencies.blockedSummary": "{count, plural, zero {لا تنتظر أي مهمة مفتوحة} one {تنتظر مهمة مفتوحة واحدة} two {تنتظر مهمتين مفتوحتين} few {تنتظر # مهام مفتوحة} many {تنتظر # مهمة مفتوحة} other {تنتظر # مهمة مفتوحة}}",
  "planning.dependencies.ready": "جاهزة: كل ما تنتظره أُنجز",
  "planning.dependencies.emptyBlockedBy": "لا تنتظر أي مهمة. أضف ما يجب إنجازه أولًا.",
  "planning.dependencies.emptyBlocking": "لا توجد مهمة تنتظر هذه المهمة.",
  "planning.dependencies.add": "إضافة مهمة تنتظرها",
  "planning.dependencies.search": "ابحث في مهام هذا المشروع",
  "planning.dependencies.searching": "جارٍ البحث…",
  "planning.dependencies.noMatch": "لا توجد مهمة مطابقة.",
  "planning.dependencies.remove": "إزالة الارتباط مع {reference}",
  "planning.dependencies.cycle": "{reference} تنتظر هذه المهمة بالفعل، مباشرة أو عبر مهام أخرى، لذا لا يمكن أن تنتظرها هذه المهمة.",
  "planning.dependencies.addError": "تعذّر ربط المهمتين. حاول مرة أخرى.",
  "planning.dependencies.removeError": "تعذّرت إزالة الارتباط. حاول مرة أخرى.",
  "planning.dependencies.loadError": "تعذّر تحميل الاعتماديات.",
  "planning.dependencies.stillBlocked": "{reference} ما زالت تنتظر {blockers}",
  "planning.dependencies.stillBlockedCount": "{reference} ما زالت تنتظر {count, plural, zero {أي مهمة} one {مهمة مفتوحة واحدة} two {مهمتين مفتوحتين} few {# مهام مفتوحة} many {# مهمة مفتوحة} other {# مهمة مفتوحة}}",
  "planning.dependencies.warnOnly": "نُقلت رغم ذلك: الاعتمادية تذكير وليست قفلًا.",
  "planning.card.blocked": "{count, plural, zero {لا تنتظر أي مهمة مفتوحة} one {تنتظر مهمة مفتوحة واحدة} two {تنتظر مهمتين مفتوحتين} few {تنتظر # مهام مفتوحة} many {تنتظر # مهمة مفتوحة} other {تنتظر # مهمة مفتوحة}}",
  "planning.card.repeats": "تتكرر: {rule}",
  "planning.list.blocked": "معطّلة",
  "planning.list.blockedFilter": "المهام المعطّلة فقط",
  "planning.repeat.label": "التكرار",
  "planning.repeat.none": "لا تتكرر",
  "planning.repeat.next": "التالية: {date}",
  "planning.repeat.choose": "كم مرة تتكرر",
  "planning.repeat.custom": "مخصص…",
  "planning.repeat.stop": "إيقاف التكرار",
  "planning.repeat.saveError": "تعذّر حفظ التكرار. حاول مرة أخرى.",
  "planning.repeat.conflict": "غيّر شخص آخر هذا التكرار. أُعيد تحميله.",
  "planning.repeat.everyWorkday": "كل يوم عمل",
  "planning.repeat.daily": "{interval, plural, zero {كل يوم} one {كل يوم} two {كل يومين} few {كل # أيام} many {كل # يومًا} other {كل # يوم}}",
  "planning.repeat.weeklyEvery": "كل {weekdays}",
  "planning.repeat.weekly": "{interval, plural, zero {كل أسبوع يوم {weekdays}} one {كل أسبوع يوم {weekdays}} two {كل أسبوعين يوم {weekdays}} few {كل # أسابيع يوم {weekdays}} many {كل # أسبوعًا يوم {weekdays}} other {كل # أسبوع يوم {weekdays}}}",
  "planning.repeat.monthly": "{interval, plural, zero {كل شهر يوم {day}} one {كل شهر يوم {day}} two {كل شهرين يوم {day}} few {كل # أشهر يوم {day}} many {كل # شهرًا يوم {day}} other {كل # شهر يوم {day}}}",
  "planning.repeat.monthlyLast": "{interval, plural, zero {كل شهر في آخر يوم منه} one {كل شهر في آخر يوم منه} two {كل شهرين في آخر يوم من الشهر} few {كل # أشهر في آخر يوم من الشهر} many {كل # شهرًا في آخر يوم من الشهر} other {كل # شهر في آخر يوم من الشهر}}",
  "planning.repeat.offWeekends": "{rule}، مع نقل عطلة نهاية الأسبوع إلى الأحد",
  "planning.repeat.until": "{rule}، حتى {date}",
  "planning.repeat.times": "{rule}، {count, plural, zero {ولا مرة} one {مرة واحدة} two {مرتين} few {# مرات} many {# مرة} other {# مرة}}",
  "planning.repeat.day.0": "أحد",
  "planning.repeat.day.1": "اثنين",
  "planning.repeat.day.2": "ثلاثاء",
  "planning.repeat.day.3": "أربعاء",
  "planning.repeat.day.4": "خميس",
  "planning.repeat.day.5": "جمعة",
  "planning.repeat.day.6": "سبت",
  "planning.repeat.form.title": "تكرار مخصص",
  "planning.repeat.form.frequency": "يتكرر",
  "planning.repeat.form.daily": "يوميًا",
  "planning.repeat.form.weekly": "أسبوعيًا",
  "planning.repeat.form.monthly": "شهريًا",
  "planning.repeat.form.every": "كل",
  "planning.repeat.form.unit.daily": "{count, plural, zero {يوم} one {يوم} two {يومين} few {أيام} many {يومًا} other {يوم}}",
  "planning.repeat.form.unit.weekly": "{count, plural, zero {أسبوع} one {أسبوع} two {أسبوعين} few {أسابيع} many {أسبوعًا} other {أسبوع}}",
  "planning.repeat.form.unit.monthly": "{count, plural, zero {شهر} one {شهر} two {شهرين} few {أشهر} many {شهرًا} other {شهر}}",
  "planning.repeat.form.onDays": "في",
  "planning.repeat.form.pickDay": "اختر يومًا واحدًا على الأقل.",
  "planning.repeat.form.dayOfMonth": "في يوم",
  "planning.repeat.form.dayOfMonthHint": "اليوم 31 يقع في آخر يوم من الأشهر الأقصر.",
  "planning.repeat.form.workdaysOnly": "انقل الجمعة والسبت إلى الأحد",
  "planning.repeat.form.ends": "ينتهي",
  "planning.repeat.form.endsNever": "أبدًا",
  "planning.repeat.form.endsOn": "في",
  "planning.repeat.form.endsAfter": "بعد",
  "planning.repeat.form.endDate": "تاريخ الانتهاء",
  "planning.repeat.form.count": "عدد المرات",
  "planning.repeat.form.timesUnit": "{count, plural, zero {مرة} one {مرة} two {مرتين} few {مرات} many {مرة} other {مرة}}",
  "planning.repeat.form.save": "حفظ التكرار",
  "planning.repeat.form.back": "رجوع",
  "planning.repeat.form.preview": "معاينة"
}
